{
  "de": {
    "worksheet": {
      "autoSave": {
        "saved": "Änderungen gespeichert",
        "saveFailed": "Änderungen konnten nicht gespeichert werden",
        "sessionExpired": "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an, um Änderungen zu speichern.",
        "draftRestoreFailed": "Entwurf konnte nicht wiederhergestellt werden"
      },
      "submitFailed": "Abgabe fehlgeschlagen. Bitte versuche es erneut.",
      "aiGenerator": {
        "breadcrumbs": {
          "course": "Kurs",
          "focus": "Fokus definieren",
          "knowledge": "Wissen",
          "tasks": "Aufgaben auswählen",
          "topic": "Thema",
          "verify": "Arbeitsblatt prüfen"
        },
        "buttons": {
          "createProposals": "Vorschläge anlegen",
          "createWorksheet": "Arbeitsblatt erstellen",
          "creating": "Verarbeitung läuft …",
          "generateLearningObjectives": "Lernziele von KI anlegen lassen",
          "generateNewProposals": "Alternative Vorschläge generieren",
          "generateTextBasis": "Grundlagentext von KI anlegen lassen",
          "regenerateLearningObjectives": "Lernziele neu anlegen lassen",
          "regenerateTextBasis": "Grundlagentext neu anlegen lassen",
          "retry": "Nochmal versuchen",
          "showTextBasis": "Textgrundlage auf dem Arbeitsblatt anzeigen"
        },
        "course": {
          "grade": "Klassenstufe",
          "language": "Sprache",
          "school": "Schulform",
          "subject": "Schulfach"
        },
        "descriptions": {
          "fillInTheBlank": "Fülle den Lückentext aus. Verwende die folgenden Begriffe:<br/><strong>{hints}</strong>"
        },
        "errors": {
          "generationFailed": "Das Arbeitsblatt konnte nicht erstellt werden. Bitte versuche es erneut."
        },
        "headers": {
          "createTitle": "Arbeitsblatt mit KI-Assistenz erstellen",
          "kinds": {
            "fill_in_the_blank_text": "Lückentext auswählen",
            "multiple_choice": "Multiple Choice Aufgabe auswählen",
            "single_choice": "Single Choice Aufgabe auswählen",
            "text": "Vorschlag für eine kurze Einführung ins Thema",
            "text_assignment": "Textaufgabe auswählen",
            "text_assignment_1": "Textaufgabe (AFB I) auswählen",
            "text_assignment_2": "Textaufgabe (AFB II) auswählen",
            "text_assignment_3": "Textaufgabe (AFB III) auswählen"
          },
          "sampleSolution": "Musterlösung:",
          "title": "Arbeitsblatt mit KI-Assistenz anlegen"
        },
        "hints": {
          "creatingLearningObjectives": "KI erstellt Lernziele",
          "creatingTextBasis": "KI erstellt Grundlagentext",
          "error": "Es gab einen Fehler. Leider konnten wir keine Vorschläge für dich anlegen.",
          "learningObjectives": "Konkrete Lernziele helfen dabei, den Kontext der Aufgaben genauer zu definieren und so passendere Vorschläge zu bekommen.",
          "progressMessage": "Aufgaben werden erstellt",
          "prompt": "Tipp: Je spezifischer du bist, desto konkreter werden die vorgeschlagenen Aufgaben.",
          "textBasis": "Der Grundlagentext dient dazu, den Fokus des Arbeitsblatts zu schärfen."
        },
        "knowledge": {
          "subtitle": "Optional kannst du eine Quelle hinzufügen, aus der die KI das Hintergrundwissen für das Arbeitsblatt extrahiert."
        },
        "labels": {
          "gradeLevel": "Altersstufe auswählen",
          "languageLevel": "Sprachniveau (GER) auswählen",
          "learningObjectiveHeading": "Lernziel für dieses Arbeitsblatt",
          "learningObjectives": "Lernziele (optional)",
          "schoolType": "Schulform auswählen",
          "subjectType": "Fach auswählen",
          "textBasis": "Auf welche Inhalte soll sich das Arbeitsblatt beziehen?",
          "topic": "Thema oder Fragestellung",
          "topicHeading": "Thema oder Fragestellung für dieses Arbeitsblatt",
          "worksheetLanguage": "Sprache auswählen"
        },
        "placeholders": {
          "learningObjectiveHeading": "Welche Kompetenzen sollen aufgebaut werden? (z. B. Analyse und Beurteilung der Startbedingungen der Weimarer Republik).",
          "learningObjectives": "Lernziele eingeben...",
          "prompt": "Nenne die wesentlichen Inhalte, auf die die Aufgaben Bezug nehmen sollen. Zum Beispiel: Der Beginn der Weimarer Republik.",
          "textBasis": "Grundlagentext eingeben...",
          "topicHeading": "Welche Hauptthemen soll das Arbeitsblatt behandeln? (z. B. „Der Beginn der Weimarer Republik“)"
        }
      },
      "aiPromptModal2": {
        "headers": {
          "title": "Textaufgabe mit KI generieren"
        },
        "labels": {
          "prompt": "Anforderungen"
        },
        "placeholders": {
          "prompt": "Beschreibe den Fokus der Aufgabe und gib ggf. eine Leitfrage oder Lernziel an."
        },
        "description": "Was möchtest du erstellen?"
      },
      "aiGeneration": {
        "createWithAi": "Mit KI erstellen",
        "dropdownLabel": "KI-Optionen zum Generieren",
        "pending": "KI erstellt Inhalt...",
        "menu": {
          "newVariant": "Inhalt variieren",
          "harder": "Schwierigere Aufgabe",
          "easier": "Einfachere Aufgabe",
          "addHelp": "Hinweise ergänzen",
          "simpleLanguage": "Einfache Sprache",
          "custom": "Eigene Anfrage"
        },
        "prompts": {
          "newBlock": "Erstelle einen passenden {blockType}-Block als nächsten sinnvollen Schritt in diesem Arbeitsblatt.",
          "newVariant": "Erstelle eine Variante dieses Blocks: Wechsle Kontext, Zahlen oder Formulierung so, dass die Aufgabe nicht aus Erinnerung an das Original lösbar ist. Lernziel und Schwierigkeit bleiben gleich.",
          "harder": "Mache diesen Block anspruchsvoller, indem du mehr Denkleistung verlangst – nicht mehr Arbeit.",
          "easier": "Mache diesen Block leichter: Vereinfache Sprache und Struktur und entferne unnötige Informationen. Lernziel und Fachbegriffe bleiben – erkläre Fachbegriffe, statt sie zu ersetzen.",
          "addHelp": "Ergänze hilfreiche Hinweise, Zwischenschritte oder Beispiele, ohne die Lösung vorwegzunehmen.",
          "simpleLanguage": "Formuliere diesen Block in einfacher Sprache. Behalte Fachbegriffe aus Lernziel und Block bei und erkläre sie bei Bedarf.",
          "guidance": {
            "fillInTheBlank": "Für Lückentext: Fülle Beschreibung und Lückentext; variiere die Lücken passend zur Anfrage."
          }
        }
      },
      "aiContext": {
        "title": "KI-Einstellungen Arbeitsblatt",
        "button": "KI-Einstellungen",
        "description": "Bestimme hier, für wen das Arbeitsblatt ist. Mit diesen Informationen kann die KI besser Aufgaben für dich erstellen.",
        "sections": {
          "schoolDetails": {
            "title": "Schulische Eckdaten"
          },
          "backgroundKnowledge": {
            "title": "Hintergrundwissen"
          }
        },
        "labels": {
          "subjectTypes": "Schulfach",
          "schoolTypes": "Schulform",
          "gradeLevels": "Klassenstufe",
          "locale": "Sprache",
          "addBackgroundKnowledge": "Hintergrundwissen hinzufügen"
        },
        "descriptions": {
          "addBackgroundKnowledge": "Füge Hintergrundwissen aus verschiedenen Quellen hinzu, zum Beispiel per Dateiupload sowie aus Webseiten, YouTube-Videos, Audiodateien oder Videos."
        },
        "actions": {
          "removeSource": "Quelle entfernen"
        },
        "hints": {
          "hasSources": "Quellen vorhanden"
        },
        "sourceKinds": {
          "text": "Text",
          "file": "Datei",
          "pdf": "PDF",
          "image": "Bild",
          "website": "Webseite",
          "youtube": "YouTube",
          "audio": "Audio",
          "video": "Video"
        },
        "flash": {
          "saveFailed": "KI-Einstellungen konnten nicht gespeichert werden"
        },
        "sourcePicker": {
          "title": "Hintergrundwissen hinzufügen",
          "subtitle": "Wähle eine Quelle aus und die KI extrahiert davon den Text als Hintergrundwissen für das Arbeitsblatt."
        },
        "recent": {
          "empty": "Noch keine Quellen vorhanden. Füge zuerst Hintergrundwissen hinzu.",
          "error": "Die zuletzt verwendeten Quellen konnten nicht geladen werden."
        }
      },
      "blockTypes": {
        "Divider": "Trennlinie",
        "File": "Datei",
        "FillInTheBlankText": "Lückentext",
        "H5p": "H5P",
        "Hint": "Tipp",
        "Image": "Bild",
        "MultipleChoice": "Multiple Choice",
        "SingleChoice": "Single Choice",
        "Spacer": "Abstand",
        "PageBreak": "Seitenumbruch",
        "StaticText": "Text",
        "Text": "Textantwort",
        "Upload": "Datei Anfordern",
        "Video": "Video",
        "ToTeachExercise": "to teach Übung"
      },
      "blockTypesV2": {
        "Upload": "Datei Anfordern",
        "ToTeachExercise": "to teach Übung"
      },
      "inserterHints": {
        "toTeachExercise": "Neu: Verwende deine Inhalte von to teach in deinen fobizz Arbeitsblättern.",
        "pageBreak": "Neu: Fokussiere die Ansicht durch Seitenumbrüche."
      },
      "navigation": {
        "headline": "Dein Fortschritt",
        "previousPage": "Zurück",
        "nextPage": "Nächste Seite"
      },
      "buttons": {
        "addOption": "Option hinzufügen",
        "submit": "Abgeben",
        "confirmDelete": "Ja, löschen",
        "duplicate": "Duplizieren",
        "generate": "Generieren",
        "deleteResponse": "Abgabe löschen",
        "moveDown": "Runter schieben",
        "moveUp": "Hoch schieben",
        "remove": "Entfernen",
        "removeOption": "Option entfernen"
      },
      "elements": "Elemente",
      "addNewBlock": "Neuen Block hinzufügen",
      "multimedia": "Multimedia",
      "layout": "Layout",
      "feedback": {
        "form": {
          "actions": {
            "reset": {
              "label": "Feedback löschen",
              "message": {
                "success": "Feedback gelöscht"
              }
            },
            "submit": {
              "label": "Feedback speichern",
              "message": {
                "error": "Feedback konnte nicht gespeichert werden",
                "success": "Feedback gespeichert"
              }
            }
          },
          "fieldset": {
            "text": {
              "label": "Textnachricht schreiben"
            }
          },
          "headline": "Individuelles Feedback geben"
        },
        "public": {
          "headline": "Feedback von {name} zu deiner Abgabe"
        },
        "shareLinkBox": "Link zur Abgabe mit Feedback teilen",
        "status": {
          "hasFeedback": "Feedback gegeben"
        }
      },
      "fillInTheBlankDefault": {
        "answerOption": "Dies ist ein Beispiel für einen Lückentext mit einer {'{'} Lücke {'}'}. Es können {'{'} viele/mehrere/verschiedene {'}'} Antwortmöglichkeiten angegeben werden. In diesem Fall wäre im ersten Satz 'Lücke' die korrekte Antwort. Im zweiten Satz wären sowohl 'viele' als auch 'mehrere' und 'verschiedene' richtig.'",
        "description": "Dein Beschreibungstext mit Hinweisen zur Bearbeitung (nicht der Lückentext). Du kannst hier auch Lösungsvorschläge zur Zuordnung anbieten, bspw. so: 'Fülle den Lückentext mit folgenden Begriffen aus: <i><mark>Wort 1</mark></i>, <i><mark>Wort 2</mark></i>...'"
      },
      "fillInTheBlankEditor": {
        "descriptionLabel": "Beschreibungstext",
        "descriptionHint": "Nutze den Beschreibungstext für Bearbeitungshinweise. Du kannst hier auch Lösungsvorschläge zur Zuordnung anbieten. Zum Beispiel {italic}",
        "descriptionHintItalic": "\"Fülle den Lückentext mit folgenden Begriffen aus: Deutschland, Bundesland, Republik,...\"",
        "clozeLabel": "Lückentext",
        "clozeHint": "\"Beispiel für einen Lückentext mit einer <strong>{'{'} Lücke {'}'}</strong>. Es können <strong>{'{'} viele/mehrere {'}'}</strong> Antworten festgelegt werden.\" In diesem Fall wäre 'Lücke' die korrekte Antwort und im zweiten Satz wären 'viele' als auch 'mehrere' richtig.",
        "insertGap": "Lücke einfügen"
      },
      "flash": {
        "addOptionSuccess": "Option hinzugefügt",
        "createBlockSuccess": "Block hinzugefügt",
        "createSolutionSuccess": "Lösung hinzugefügt",
        "deleteBlockSuccess": "Block gelöscht",
        "duplicateBlockSuccess": "Block dupliziert",
        "deleteOptionSuccess": "Option entfernt",
        "deleteSolutionSuccess": "Lösung gelöscht",
        "moveBlockSuccess": "Block verschoben",
        "updateBlockSuccess": "Block aktualisiert",
        "updateClozeTestSuccess": "Lückentext aktualisiert",
        "updateOptionSuccess": "Option aktualisiert",
        "updateSolutionSuccess": "Lösung aktualisiert",
        "updateWorksheetSuccess": "Arbeitsblatt aktualisiert",
        "updateWorksheetError": "Arbeitsblatt konnte nicht aktualisiert werden"
      },
      "headings": {
        "saveShareLink": "Merke dir diesen Link, damit du deine Ergebnisse später einfach wiederfindest."
      },
      "hints": {
        "Divider": "Nutze die Trennlinie, um das Arbeitsblatt visuell zu strukturieren und einen Bereich vom darauf folgenden abzugrenzen.",
        "File": "Füge hier Arbeitsmaterial (z. B. eine Textdatei, ein Bild oder eine PDF) ein, das deine Schüler*innen sich herunterladen oder anschauen sollen. Tipp: Nutze den Upload-Aufgabenblock, um die bearbeitete Datei direkt von deinen Schüler*innen wieder einzusammeln.",
        "FillInTheBlankText": "Schreibe einen Lückentext oder eine Frage mit einer einzigen Antwortlücke. Verwende die Symbole {'{'} und {'}'}, um eine Lücke zu markieren und die möglichen Lösungswörter zu umschließen. Wenn mehr als nur ein Wort richtig sein kann, trenne die Lösungswörter mit einem /. Ein Beispielsatz könnte lauten: \"Die Schülerinnen und Schüler müssen {'{'}eine/die{'}'} Lücke ausfüllen.\" Hier ist sowohl 'eine' als auch 'die' eine richtige Antwort. Alle Antworten werden direkt ausgewertet.",
        "H5p": "Binde interaktive H5P-Inhalte in dein Arbeitsblatt ein. Lade eine .h5p-Datei hoch, um interaktive Übungen, Quizzes und Lernspiele zu erstellen.",
        "Hint": "Gib deinen Schüler*innen extra Tipps mit diesem visuell hervorgehobenen Text-Hinweis.",
        "Image": "Füge ein Bild aus der Bildersuche hinzu oder lade ein eigenes Bild hoch, um dein Arbeitsblatt mit visuellem Inhalt anzureichern.",
        "MultipleChoice": "Stelle eine Frage und trage die Antwortmöglichkeiten ein. Markiere die korrekten Antworten mit Klick auf den Kreis davor. Die Auswertung zeigt dir direkt, bei welchen Aufgaben bei deinen Schüler*innen die größte Sicherheit – oder der größte Wiederholungsbedarf – besteht.",
        "SingleChoice": "Stelle eine Frage und trage die Antwortmöglichkeiten ein. Markiere die korrekte Antwort mit Klick auf den Kreis davor. Die Auswertung zeigt dir direkt, bei welchen Aufgaben bei deinen Schüler*innen die größte Sicherheit – oder der größte Wiederholungsbedarf – besteht.",
        "Spacer": "Füge deinem Arbeitsblatt Abstände hinzu, um die Inhalte übersichtlicher zu gestalten.",
        "PageBreak": "Nutze den Seitenumbruch, um das Arbeitsblatt in mehrere Seiten aufzuteilen, zwischen denen navigiert werden kann.",
        "StaticText": "Nutze das Textelement, um deinen Schüler*innen Erklärungen, Hinweise und zusätzliche Infos zum Bearbeiten der Aufgaben zu geben. Hinweis: hier können deine Schüler*innen - anders als bei den Abfrageblöcken - nichts digital ausfüllen.",
        "Text": "Verfasse einen Arbeitsauftrag, für den deine Schüler*innen eine Antwort in einem Textfeld digital einreichen können.",
        "Upload": "Formuliere einen Arbeitsauftrag, für den deine Schüler*innen eine Datei hochladen sollen (z. B. eine Textdatei, ein Bild oder eine PDF). Du kannst später alle eingereichten Dateien an einem Ort übersichtlich auswerten.",
        "ToTeachExercise": "Suche nach interaktiven Übungen von to teach und binde sie direkt in dein Arbeitsblatt ein.",
        "Video": "Bette YouTube- oder Vimeo-Videos per Link ein (z. B.: https://vimeo.com/469669139).",
        "answered": "beantwortet",
        "dragNDrop": "Tipp: Du kannst eine Datei per Drag & Drop direkt hochladen",
        "dropFileHere": "Datei hier hineinziehen oder Datei auswählen",
        "dropH5pFileHere": "H5P-Datei hier hineinziehen oder",
        "uploadH5pFilePrompt": "H5P-Datei hier hineinziehen oder Datei auswählen",
        "elements": "Binde Erklärungen und Inhalte für deine Schüler*innen ein und strukturiere dein Arbeitsblatt.",
        "h5pContentStatus": "Status: {status}",
        "h5pFileRequirement": "Nur .h5p-Dateien sind erlaubt",
        "h5pProcessing": "H5P-Inhalt wird verarbeitet, bitte warten...",
        "h5pProcessingFailed": "H5P-Verarbeitung fehlgeschlagen. Bitte versuche es erneut.",
        "h5pProcessingStalled": "Die Verarbeitung dieses H5P-Inhalts dauert ungewöhnlich lange. Bitte versuche es später erneut oder kontaktiere den Support.",
        "h5pReloadHint": "Inhalte werden nicht angezeigt? Seite neu laden",
        "h5pFileUploadSuccess": "H5P-Datei erfolgreich hochgeladen.",
        "h5pPreviewHint": "In der Vorschau kannst du das Modul ausprobieren.",
        "toTeachExerciseImportSuccess": "to teach Übung erfolgreich importiert.",
        "maxOptionsReached": "Maximal {max} Optionen können hinzugefügt werden.",
        "name": "Trage hier dein Pseudonym oder Namenskürzel ein.",
        "noDescriptionOrCloze": "Keine Beschreibung und kein Lückentext hinterlegt",
        "emptyBlock": "<strong>Dieser Block ist leer.</strong> Er erscheint weder in der Vorschau noch in der Ansicht für Schüler:innen.",
        "noDescriptionOrOptions": "Keine Beschreibung oder Optionen hinterlegt",
        "fileUploadSuccess": "Datei erfolgreich hochgeladen.",
        "noFile": "Keine Datei hochgeladen",
        "noH5pContent": "Keine H5P-Inhalte hochgeladen",
        "h5pNotPrintable": "Dieser interaktive Inhalt kann nicht gedruckt werden.",
        "noHint": "Kein Tipp eingegeben",
        "noImage": "Kein Bild hochgeladen",
        "noInput": "Keine Angabe",
        "selectFile": "Datei auswählen",
        "noSolution": "Keine Lösung hinterlegt",
        "noText": "Kein Text eingegeben",
        "noVideo": "Kein Video eingebettet",
        "processingH5pFile": "H5P-Datei wird verarbeitet...",
        "questions": "Erstelle Aufgaben mit Feldern, die deine Schüler*innen ausfüllen können.",
        "submitSuccessful": "Vielen Dank! Du hast dein Arbeitsblatt erfolgreich abgegeben.",
        "searchToTeachExercises": "to teach Übungen suchen...",
        "processingToTeachExercise": "to teach Übung wird importiert und verarbeitet...",
        "noToTeachExercisesFound": "Keine Übungen gefunden",
        "noToTeachExercise": "Keine to teach Übung ausgewählt",
        "toTeachSsoNotLinked": "Dein Konto ist noch nicht mit to teach verknüpft. Verbinde dein Konto, um deine to teach Inhalte bei fobizz zu nutzen. <a href=\"https://to-teach.ai/auth/fobizz\" target=\"_blank\" rel=\"noopener noreferrer\">Zu to teach</a>",
        "videoError": "Die eingegebene URL ist ungültig. Gib eine korrekte Adresse ein oder lösche deine Eingabe.",
        "videoExample": "Beispiel: https://vimeo.com/469669139"
      },
      "labels": {
        "clozeGap": "Lücke {current} von {total}",
        "confirmDeleteBlock": "Block löschen?",
        "confirmDeleteBlockText": "Achtung: Wenn du diesen Block entfernst, werden alle ggf. damit verbundenen Abgaben ebenfalls gelöscht.",
        "confirmDeleteResponse": "Abgabe wirklich löschen?",
        "confirmDeleteResponseText": "Soll die Abgabe wirklich gelöscht werden?",
        "confirmSubmitIncompleteResponse": "Es sind noch nicht alle Aufgaben bearbeitet. Möchtest du das Arbeitsblatt trotzdem abgeben?",
        "confirmSubmitResponse": "Möchtest du das Arbeitsblatt jetzt abgeben?",
        "confirmSubmitResponseTitle": "Arbeitsblatt abgeben?",
        "confirmSubmitKeepEditing": "Weiter bearbeiten",
        "confirmSubmitAnyway": "Ja, abgeben",
        "draft": "Entwurf | Entwürfe",
        "response": "Abgabe | Abgaben",
        "responseStatus": {
          "draft": "In Bearbeitung",
          "submitted": "Abgeschlossen"
        },
        "respondingAs": "Du beantwortest dieses Arbeitsblatt als {pseudonym}",
        "responsesTab": "Entwürfe und Abgaben",
        "worksheet": "Arbeitsblatt"
      },
      "links": {
        "shareResponse": "Zugangslink kopieren",
        "showResponseSolutionToggle": "Zeige Musterlösungen",
        "taskNo": "{ index }. Aufgabe"
      },
      "placeholders": {
        "FillInTheBlankText": "Lückentext hier eingeben",
        "answerInput": "Antwort hier eingeben",
        "clickToEdit": "Klicken zum Bearbeiten",
        "description": "Beschreibung hier eingeben",
        "hint": "Tipp hier eingeben",
        "imageCaption": "Bildunterschrift hier eingeben",
        "optionInput": "Option hier eingeben",
        "videoCaption": "Videounterschrift hier eingeben",
        "videoUrl": "Video-URL eingeben"
      },
      "promptAttributes": {
        "derivedLanguageSkillLevel": {
          "1": "in sehr einfacher Sprache und leicht verständlichen Formulierungen für Kinder zwischen 5 und 7 Jahren",
          "2": "in einfacher Sprache und leicht verständlichen Formulierungen für Kinder zwischen 7 und 10 Jahren",
          "3": "in klarer und verständlicher Sprache für Kinder zwischen 10 und 13 Jahren",
          "4": "in verständlicher Sprache und klaren Formulierungen für Jugendliche zwischen 13 und 16 Jahren",
          "5": "in angemessener Sprache und mit fachspezifischen Begriffen und Formulierungen für junge Erwachsene ab 17 Jahren oder älter"
        },
        "regeneration": {
          "prompt": "\n\nWICHTIG: Erstelle neue, deutlich unterschiedliche Vorschläge. Wiederhole keine der folgenden bisherigen Vorschläge und formuliere sie nicht nur leicht um.{strategyInstruction}\nBisherige Vorschläge:\n{previousProposals}",
          "strategyInstruction": "\nNutze diesmal gezielt diese alternative Herangehensweise: {strategy}",
          "strategies": {
            "everydayContext": "Nutze einen alltagsnahen Kontext mit konkreten Beispielen.",
            "playfulFormat": "Nutze eine spielerische oder rätselhafte Formulierung mit anderer Satzstruktur.",
            "analyticalPerspective": "Nutze eine sachlich-analytische Perspektive mit anderen inhaltlichen Schwerpunkten.",
            "creativeScenario": "Nutze eine kreative Geschichte oder ein neues Szenario als Ausgangspunkt.",
            "compareCauseEffect": "Nutze einen Vergleichs- oder Ursache-Wirkung-Fokus statt des bisherigen Zugangs."
          }
        },
        "systemPrompt": "Du bist eine {subjectType}-Lehrkraft an einer {schoolType} und kennst dich mit den Inhalten des Lehrplans für diese Zielgruppe sehr gut aus. Deine Ausgabe soll angemessen für Schüler*innen der Altersstufe {gradeLevel} und {derivedLanguageSkillLevel} formuliert sein.\n You MUST answer in JSON only. You MUST use the provided schema definition and the examples. Do not return any additional fields or text.",
        "userPrompt": {
          "fill_in_the_blank_text": "Beziehe dich bei allen Antworten auf den Basistext, der durch dreifache Anführungszeichen markiert ist. Basistext: \"\"\"{textBasis}\"\"\". Erstelle 3 Versionen eines kurzen Lückentexts mit jeweils 5 Lücken, indem du die Inhalte des Basistexts neu formulierst. Jede der 5 Lücken sollte durch geschweifte Klammern präsentiert werden und die Lösung beinhalten. Der Text sollte in JSON Format ausgegeben werden und sich vom Format her an diesem Beispiel orientieren: ",
          "learning_objectives": "Du bist ein Experte für pädagogische und fachliche Zielsetzung und fachliche Zielsetzung und für die Formulierung von Aufgabenstellungen im Fach {subjectType}, der sich auf Blooms Taxonomie spezialisiert. Deine Mission: Formuliere Lernziele für eine Unterrichtseinheit für die Klassenstufe {gradeLevel} zu dem Stundenthema '{prompt}'. Differenziere die Lernziele, sodass sie die Stufen 1-2, 3-4 und 5 der Taxonomie abdecken und formuliere 2 Lernziele pro Stufe. Gib einfache Hauptsätze aus.",
          "single_choice": "Beziehe dich bei allen Antworten auf den Basistext, der durch dreifache Anführungszeichen markiert ist. Basistext: \"\"\"{textBasis}\"\"\". Schreibe ein Quiz mit 3 Fragen und 3 Antworten einschließlich Lösung. Es darf nur eine Antwort richtig sein. Formuliere die Aufgaben immer in Du-Anrede. Der Text soll in JSON Format ausgegeben werden und sich vom Format her an diesem Beispiel orientieren: ",
          "text_assignment": "Beziehe dich bei allen Antworten auf den Basistext, der durch dreifache Anführungszeichen markiert ist. Erstelle 3 ausführliche, sich inhaltlich auf den Basistext beziehende Textaufgaben mit je einer Musterlösung, die aus etwa {\n          count\n        } Wörtern besteht. Die Aufgaben entsprechen dem Anforderungsbereich {\n          name\n        } mit der Definition: '{\n          description\n        }'. Basistext: \"\"\"{textBasis}\"\"\".\n        Formuliere die Aufgaben immer in Du-Anrede. Stelle keine W-Fragen mit den Frageworten Wer?, Was?, Wann?, Wo?, Warum?, Wie?, Wozu?, sondern wähle für jede der Aufgabenstellungen einen der folgenden Operatoren aus und nutze ihn im Imperativ: {operators}. Der Text soll in JSON Format ausgegeben werden und sich vom Format her an diesem Beispiel orientieren:     ",
          "text_basis": "Schreibe einen Sachtext als Grundlage für ein Arbeitsblatt, der für den deutschen Lehrplan im Fach {subjectType} relevante Inhalte anschaulich darstellt und erklärt. Der Text soll ausschließlich Informationen enthalten und zum Erreichen der folgenden Lernziele beitragen: '{learningObjectives}'. Das Thema des Textes ist '{prompt}'. Gib nur die angeforderten Inhalte aus und verzichte auf einleitende und abschließende Kommentare zur Rahmung der Antwort. Der Text soll aus einem einzelnen Absatz aus 100 bis 500 Wörtern bestehen und keine Sonderzeichen, keine Steuerzeichen und keine Zeilenumbrüche beinhalten. Der Text soll im JSON-Format ausgegeben werden und sich von der Datenstruktur her am folgenden Code-Beispiel orientieren: "
        }
      },
      "questions": "Abfragen",
      "solution": {
        "actions": {
          "add": "Musterlösung hinzufügen",
          "delete": "Musterlösung entfernen",
          "showResponseSolution": "Alle Lösungen nach Abgabe anzeigen"
        },
        "hints": {
          "showResponseSolution": "Deine Schüler*innen sehen die hinterlegten Musterlösungen direkt nach der Abgabe."
        },
        "title": "Musterlösung",
        "types": {
          "text": {
            "placeholder": "Musterlösung hier eingeben..."
          }
        }
      },
      "words": {
        "of": "von"
      }
    }
  }
}
